<template>
  <van-swipe
    class="swiper-img"
    :autoplay="3000"
    :height="height"
    :show-indicators="showIndicators"
  >
    <van-swipe-item v-for="(image, index) in imageList" :key="index">
      <!-- <img v-lazy="image" /> -->
      <van-image width="100%" height="100%" lazy-load :src="image">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
        <!--文本为：加载失败-->
        <template v-slot:error>{{$t('other.loadFail')}}</template>
      </van-image>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
export default {
  name: "swipeImg",
  props: {
    imageList: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number || String,
      default: 0,
    },
    showIndicators:{
      type: Boolean,
      default: false
    }
  },
};
</script>

<style lang="less" scoped>
.swiper-img {
  margin-top: 20px;
  overflow: hidden;
  border-radius: 8px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
}
</style>
